import React from 'react';

import ProfileContainer from './ProfileContainer';
import { ProfileDetail } from './ProfileDetail';

const ProfilePage: React.FC = () => (
    <ProfileContainer.Provider>
        <ProfileDetail/>
    </ProfileContainer.Provider>
);
export default ProfilePage;
